import EmployerPendingsUI from '../../../dictionaries/EmployerPendingsUI.dic';
import Ui3DotsMenu from '../../../dictionaries/Ui3DotsMenu.dic';
import addAccountToSourceList from '../../../lib/Account/addAccountToSourceList.fun';
import {
  NOT
} from '../../../lib/Boolean.lib';
import Core from '../../../lib/Core';
import {
  ACCOUNT_ACTION__ACCESS_EMPLOYER_PENDINGS,
  ACCOUNT_ACTION__EDIT_EMPLOYER
} from '../../../lib/Definition';
import Employer from '../../../lib/Employer';
import Job from '../../../lib/Job';
import {
  ROLE__LIMITED_RECRUITER,
  ROLE__TRUSTED_RECRUITER
} from '../../../lib/services/Accounts/Session.lib';
import {
  compileText
} from '../../../lib/String.lib';
import {
  matchLocation,
  reloadLocation
} from '../../../lib/URL.lib';
import openDialogAccountEmployerSelector from '../../Accounts/Libraries/openDialogAccountEmployerSelector.fun';
import openDialogAccountSelector from '../../Accounts/Libraries/openDialogAccountSelector.fun';
import TriggerWaitingEmployerSummary from '../../Employers/EmployerPendings/TriggerWaitingEmployerSummary';
import { openPreviewRecruiterEmployerUpdates } from '../../Engagements/RecruiterJobUpdates/PreviewRecruiterEmployerUpdates';
import Button from '../../Layout/Wrappers/Button';
import Typography from '../../Layout/Wrappers/Typography';

export const moreMenuOptionsEmployers = [
  {
    to: employer => (`/employer/edit/${employer.id}`),
    label: 'Edit Employer',
    acl: (employer) => (
      (Core.isAdmin({ action: ACCOUNT_ACTION__EDIT_EMPLOYER }) || (Core.isRecruiter() && Core.isOnDev())) &&
      NOT(matchLocation(/employer\/(create|edit)/i))
    ),
  },
  {
    acl: (employer) => Core.isAdmin({
      action: ACCOUNT_ACTION__ACCESS_EMPLOYER_PENDINGS
    }),
    label: Ui3DotsMenu.Job.employerPendings,
    to: (employer) => (`/employer/pendings/?employerId=${employer.id}`),
    target: (employer) => '_blank',
  },
  {
    acl: (employer) => Core.isAdmin({
      action: ACCOUNT_ACTION__ACCESS_EMPLOYER_PENDINGS
    }),
    label: EmployerPendingsUI.urlGeneratorDialog.title,
    action: (employer) => openDialogAccountEmployerSelector({
      employerId: employer.id
    }),
  },
  {
    acl: (employer) => Core.isAdmin({
      action: ACCOUNT_ACTION__ACCESS_EMPLOYER_PENDINGS
    }),
    render: (employer, { key, ...props }) => (
      <TriggerWaitingEmployerSummary {...props}
        employerId={employer.id}
        type='MenuItem'
      />
    )
  },
  {
    acl: (employer) => Core.isAdmin(),
    label: Ui3DotsMenu.Employer.intakeAttendance,
    action: (employer) => openDialogAccountSelector({
      title: Ui3DotsMenu.Employer.intakeAttendance,
      where: {
        role: {
          inq: [
            ROLE__TRUSTED_RECRUITER,
            ROLE__LIMITED_RECRUITER
          ]
        }
      },
      onApply: (accountIds) => addAccountToSourceList({
        employerId: employer.id,
        accountIds
      }),
    })
  },
  {
    acl: (employer) => Core.isAdmin(),
    label: String(
      Ui3DotsMenu.Employer.previewRecruiterEmployerUpdates
    ).replace('(employer updates)', '').trim(),
    action: ({ id: employerId }) => openPreviewRecruiterEmployerUpdates({
      employerId
    }),
  },
  {
    label: (
      <Typography className='c-red'>
        {compileText(Ui3DotsMenu.Common.deleteEntity, {
          ENTITY: matchLocation(/\/(create|edit)/i) ? '' : Ui3DotsMenu.Employer.ENTITY
        })}
      </Typography>
    ),
    action: employer => deleteEmployer(employer),
    acl: employer => Core.isAdmin({ action: ACCOUNT_ACTION__EDIT_EMPLOYER }),
  }
];

function deleteEmployer(employer) {
  Job.getWhere({ employerId: employer.id }).then(
    jobs =>
      Core.dialog.open({
        title: 'Confirm',
        message: `Delete "${employer._name}"${!!jobs.length
          ? ` and ${jobs.length} job${jobs.length === 1 ? "" : "s"
          }?`
          : ""
          }`,
        paperStyle: { width: 640 },
        actions: [
          <Button outlined secondary minW120
            onClick={Core.dialog.close}
          >
            Cancel
          </Button>,
          <Button error minW120
            onClick={
              ev =>
                Employer.delete(employer.id,
                  response => {
                    Core.showSuccess(
                      "Employer was deleted successfully"
                    );
                    reloadLocation();
                  },
                  error => {
                    if (!!error) {
                      Core.showWarning("Can not delete employer. Please contact support.");
                    }
                  }
                )
            }>
            Confirm
          </Button>
        ]
      })
  )
}